import Authenticated from "@/Layouts/Authenticated";
import { useForm, usePage } from "@inertiajs/inertia-react";
import { Inertia } from "@inertiajs/inertia";
import PageHeading from "@/Components/PageHeading";
import MultiSelectInput from "@/Components/MultiSelectInput";
import LoadingButton from "@/Components/LoadingButton";

const GroupAlert = () => {
    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Fee", route: route("fees") },
        { name: "Group Alert", route: null },
    ];

    const { groups } = usePage().props;

    const { data, setData, errors, post, processing, transform, reset } =
        useForm({
            groups: [],
        });

    transform((data) => ({
        ...data,
        groups: _.map(data.groups, "id"),
    }));

    function handleSubmit(e) {
        e.preventDefault();
        post(route("fees.alert.group"), {
            onSuccess: () => reset(),
        });
    }

    function handleCancel(e) {
        e.preventDefault();
        Inertia.visit(route("fees"));
    }

    return (
        <div className="py-6">
            <PageHeading
                heading={"Send Fee Alert (Groups)"}
                breadcrumb={breadcrumb}
            />
            <div className="mt-8">
                <div className="mx-auto max-w-lg px-4 py-10 pb-12 lg:pb-16">
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-6">
                            <div>
                                <MultiSelectInput
                                    items={groups}
                                    selected={data.groups}
                                    setSelected={(e) => setData("groups", e)}
                                    errors={errors.groups}
                                />
                            </div>
                        </div>
                        <div className="pt-5">
                            <div className="flex justify-end space-x-1">
                                <LoadingButton
                                    type={"button"}
                                    onClick={handleCancel}
                                    loading={processing}
                                    className="btn-secondary"
                                >
                                    Cancel
                                </LoadingButton>
                                <LoadingButton
                                    type={"submit"}
                                    loading={processing}
                                    className={"btn-primary"}
                                >
                                    Submit
                                </LoadingButton>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

GroupAlert.layout = (page) => (
    <Authenticated title={"Group Fee Alert"} children={page} />
);

export default GroupAlert;
